import { render, staticRenderFns } from "./ProjectManagement.vue?vue&type=template&id=349426ab"
import script from "./ProjectManagement.vue?vue&type=script&lang=js"
export * from "./ProjectManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports